<template>
    <Head>
        <title>Wakaf Pahang - Maklumat pewakaf bagi {{ data.nama }}</title>
        <link rel="shortcut apple-touch-icon icon" fetchpriority="high" as="image" :href="img_favicon" type="image/png">
    </Head>
    <div class="container-fluid mt-5 d-print-none">
        <div class="d-flex justify-content-center">
            <span class="fs-4">Nama pegawai: {{ officer }}</span>
        </div>
        <div class="d-flex justify-content-end">
            <Link replace v-if="officer_uri !== undefined" class="btn btn-warning me-2 d-print-none" :href="officer_uri"><font-awesome-icon :icon="faMoneyBillTransfer" class="pe-2" />Wakaf lagi</Link>
            <button class="btn btn-danger d-print-none" :class="{'d-none': isWindowOpened}" @click="openAction('close')">
                <font-awesome-icon :icon="faXmark" />
            </button>
        </div>
        <iframe
            :src="uri+'#pagemode=none&navpanes=0'"
            class="mt-3"
            style="width: 100%; height: 80svh; display: block; border: none;">
        </iframe>
    </div>
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import Swal from "sweetalert2";
import { Head, Link } from "@inertiajs/vue3";
import { faPrint, faXmark, faMoneyBillTransfer} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fb } from "facebook-pixel";
import { gtag, install } from "ga-gtag";

library.add(faPrint, faXmark, faMoneyBillTransfer);


const data = defineProps<{
    uri: string,
    nama: string,
    officer: string,
    img_favicon: string,
    identifier?: number,
    cummulative?: number,
    btn_sw?: string,
    officer_uri?: string,
    success?: boolean,
    callFb?: boolean,
    callGoogle?: boolean,
    google_id?: string,
    fb_id?: number,
}>();

const openAction = (act: String):void =>{
    switch (act) {
        case "close":window.close();break;
    }
}

const isWindowOpened = ref<boolean>(false);

onMounted(() => {
    if(window.opener === null) {
        isWindowOpened.value = true;
    }
    if (data.success) {
        thankYouModal();
    }
    if(data.callFb){
        sendFacebookTracking();
    }
    if(data.callGoogle){
        sendGoogleTracking();
    }
});

const thankYouModal = () :void => {
    Swal.fire({
        title: 'جَزَاكُمُ اللهُ خَيْرًا كَثِيْرًا وَجَزَاكُمُ اللهُ اَحْسَنَ الْجَزَاء',
        html: 'Semoga Allah S.W.T. menganugerahkan sebaik-baik ganjaran ke atas harta yang diwakafkan dan diberikan keberkatan serta kebahagiaan yang berkekalan kepada anda.',
        icon: 'info',
        confirmButtonText: 'Tutup',
        timer: 10000,
        timerProgressBar: true,
        showClass: {
            popup: 'animate__animated animate__tada'
        },
        hideClass: {
            popup: 'animate__animated animate__fadeOutDown'
        }
    }).then(function () {
        const url = new URL(document.URL);
        url.search = "";
        history.replaceState({}, '', url.toString());
    });

}

const sendGoogleTracking = () =>{
    install(data.google_id!);
    gtag("event", "purchase", {
        transaction_id: data.identifier,
        value: data.cummulative,
    });
}
const sendFacebookTracking = () =>{
    fb.config({
        autoPageView: true,
        pixel: data.fb_id!,
        disabled: false
    })
    fb.track("Purchase", {
        value: data.cummulative,
        currency: "MYR",
        content_ids: [data.identifier!],
    })
}
</script>

<style scoped>
</style>
